import { AdminCostcenter } from '../model/adminCostcenter';
export class AdminCostcenterBuilder {
    static buildAdminCostcenter(data) {
        let cc = new AdminCostcenter();
        cc.id = data.id;
        cc.id_company = data.id_company;
        cc.company_name = data.company_name;
        cc.costcenter_name = data.costcenter_name;
        cc.id_paymethod = data.id_paymethod;
        cc.date_register = data.date_register ? new Date(data.date_register) : null;
        cc.date_modified = data.date_modified ? new Date(data.date_modified) : null;
        cc.active = data.active;
        return cc;
    }
}
//# sourceMappingURL=adminCostcenter-builder.js.map